import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
const isredirectUrl = window?.location?.href?.includes('vineyard-partners');
const baseName = isredirectUrl ? '/vineyard-partners' : '/jsp/vineyardpartners/us/home.jsp';

ReactDOM.render(
  <BrowserRouter basename={baseName}>
    <App />
  </BrowserRouter>,
  document.getElementById('vpp-app'),
);
